import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const getLive = () => dispatch => {
	Xhr.getLiveNow().then((resp) => {
		dispatch({
			type : ACTIONS.MAIN_LIVE.RECEIVE_PROPS,
			data : resp ? resp.data : [],
		})
	});
};

export const getLiveSoon = () => dispatch => {
	Xhr.getLiveSoon().then((resp) => dispatch({
		type : ACTIONS.MAIN_LIVE_SOON.RECEIVE_PROPS,
		data : resp.data,
	}));
};

export const toggleFavorite = (data) => dispatch => {
	dispatch({type : ACTIONS.FAVORITES.TOGGLE, data : data});
};

export const deleteFavorite = (data) => dispatch => {
	dispatch({type : ACTIONS.FAVORITES.DELETE, data : data});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/live.js